import { apiFetch } from '../../../lib/api';

export const startAdminImpersonation = async (userId, token, reason = null) => {
  return apiFetch('/api/v1/auth/admin/impersonate', {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: JSON.stringify({
      user_id: userId,
      ...(reason ? { reason } : {}),
    }),
  });
};

export const endAdminImpersonation = async (token) => {
  return apiFetch('/api/v1/auth/admin/impersonate/end', {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
};
